export default class MsgTree {
  constructor(el) {
    this.el = el;
    this.formContainer = this.el.querySelector('#form-container');
    this.showTreeButton = this.el.querySelector('#show-tree-button');
    this.confirmContainer = this.el.querySelector('#confirm-container');
    this.confirmButton = this.el.querySelector('#confirm-button');
    this.cancelButton = this.el.querySelector('#cancel-button');
    this.confirmID = this.el.querySelector('#confirm-id');
    this.outputContainer = this.el.querySelector('#tree-output');
    this.outputContainer = this.el.querySelector('#tree-output');
    this.resultContainer = this.el.querySelector('#result-container');
    this.outputAmount = this.el.querySelector('#amount');
    this.userid = this.el.querySelector('input[name="uid"]');

    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.cancelButton.addEventListener('click', () => {
      this.confirmID.innerHTML = this.userid.value;
      this.formContainer.classList.remove('hidden');
      this.confirmContainer.classList.add('hidden');
      this.resultContainer.classList.add('hidden');
      this.confirmID.innerHTML = '';
      this.outputContainer.innerHTML = '';
      this.outputAmount.innerHTML = '0 ';
      this.userid.value = '';
      window.scrollTo(0, 0);
    });
    this.showTreeButton.addEventListener('click', () => {
      if (!this.userid.value) {
        return;
      }

      const userId = this.userid.value;

      $('#result-container').addClass('hidden');
      $('#confirm-container').addClass('hidden');
      $('#tree-output').text('');

      fetch(`/api/v1/public/all-message-threads/${userId}`)
        .then(response => response.json())
        .then(jsMessage => {
          if(typeof jsMessage.messages == 'undefined'
          || jsMessage.messages.length == 0){
            
            $('#result-container').removeClass('hidden');
            $('#removeMessagePanelTitle').html(i8n.removeMessagePanelTitle)

            return false;
          }

          // eslint-disable-next-line no-restricted-syntax
          for (const message of jsMessage.messages) {
            const messageItemWrap = $('<div>').addClass('message-thread-item row');

            const msgTimeObj = new Date(message.timestamp);

            const senderName = message.senderUserName
            const receiverName = message.receiverUserName

            const messageItemContentWrap = $('<div>')
              .addClass('row');

            const messageItemTime = $('<div>')
              .addClass('message-thread-item-time ')
              .text(msgTimeObj.toLocaleString(mailloc.iso4, mailloc.DateOptions));

            const messageItemPartners = $('<div>')
              .addClass('message-thread-item-partners')
              .text(senderName + ' -> ' + receiverName)

            let textStr;

            textStr =
              message.type == 'CUSTOM'
                ? message.message
                : i8n.message_text['SENDER'][message.type];

            textStr = textStr.replace('{RECEIVER}', receiverName);
            textStr = textStr.replace('{SENDER}', senderName);

            const messageItemText = $('<div>')
              .addClass('message-thread-item-text row')
              .append(
                $('<div>')
                  .addClass('col-sm-12')
                  .html(
                    textStr
                  )
              );

            messageItemContentWrap.append(messageItemTime);

            messageItemContentWrap.append(messageItemPartners);

            messageItemWrap.append(messageItemContentWrap);

            messageItemWrap.append(messageItemText);

            $('#tree-output').append(messageItemWrap);
          }

          $('#removeMessagePanelTitle').text(i8n.removeMessagePanelTitle.replace("<span id=\"amount\">0 </span>", jsMessage.messages.length + ' '))

          $('#result-container').removeClass('hidden');
          $('#confirm-container').removeClass('hidden');

        });
    });
    this.confirmButton.addEventListener('click', () => {

      const userId = this.userid.value;

      fetch(`/api/v1/public/all-message-threads/${userId}`, { method: "DELETE" } )
        .then(  (response) =>  {
          if (response.ok) {
            return response.json();
          }
          return Promise.reject(response);
        })
        .then(jsMessage => {
            this.outputContainer.innerHTML = '';
            this.confirmContainer.classList.add('hidden');
            this.outputAmount.innerHTML = '0 ';
            this.userid.value = '';
            window.scrollTo(0, 0);
        })
        .catch((response) => {
            response.json().then((json) => {
              console.log(json);
            })
        }
        );
    });
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/msgtree.js